export const InvoiceStandardTemplate = {
  id: 1,
  name: "Facture Standard",
  description: "Facture standard pour les clients",
  variables: [
    { key: "invoiceNumber", label: "Numéro de facture", default: "" },
    { key: "datee", label: "Date", default: new Date().toLocaleDateString() },
    { key: "clientName", label: "Nom du client", default: "" },
    { key: "amount", label: "Montant total", default: "$0.00" },
    { key: "paymentMethod", label: "Méthode de paiement", default: "" },
    { key: "dueDate", label: "Date d'échéance", default: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString() },
    { key: "termsAndConditions", label: "Termes et conditions", default: "" },
    { key: "logoUrl", label: "URL du logo", default: "" },
    { key: "companyName", label: "Nom de l'entreprise", default: "Minpostel" },
    { key: "companyAddress", label: "Adresse de l’entreprise", default: "20 rue du Général Leclerc, 93460 Saint-Denis" },
  ],
  is_default: true,
  type: "invoice",
  reference: "invoice-standard-1",
}
